import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import { env } from '~/commons/config';
import PageNotFound from '~/commons/components/PageNotFound.jsx';

import NavAdmin from './layout/NavAdmin.jsx';
import NavStudent from './layout/NavStudent.jsx';
import FormThemeReportsManagement from './pages/FormThemeReportsManagement.jsx';
import PageThemeReportsLogin from './pages/PageThemeReportsLogin.jsx';
import PageThemeReportsAnnouncements from './pages/PageThemeReportsAnnouncements.jsx';
import PageThemeReportsDetails from './pages/PageThemeReportsDetails.jsx';
import Nav from './layout/Nav.jsx';
import ModalAlert from '../../app/components/modals/ModalAlert.jsx';
import Layout from '../../app/components/layout/Layout.jsx';
import ModalAnnouncement from '../../app/components/modals/ModalAnnouncement.jsx';
import AutoLogout from '../../app/components/blocks/AutoLogout.jsx';
import PageThemeReportsManagement from './pages/PageThemeReportsManagement.jsx';
import PageAnnouncement from '../../app/components/pages/PageAnnouncement.jsx';

const ThemeReports = () => {
  // Check if user is teacher/schoolAdmin or student (defensive: ensure roles exist)
  const roles = (env.user && env.user.roles) || [];
  // teachers may be named 'teacher' or 'schoolAdmin' in this system
  const isTeacher = roles.includes('schoolAdmin');
  const isStudent = roles.includes('student');
  // let redirectTo = '/enterthematic/login';
  // if (isTeacher) redirectTo = '/enterthematic/management/';
  // else if (isStudent) redirectTo = '/themeReports/details';
  return (
    <ModalAlert>
      <Router basename={!env.base ? '/' : env.base}>
        <Layout>
          {!isTeacher && !isStudent && <ModalAnnouncement />}
          {(isTeacher || isStudent) && <AutoLogout delay={1000 * 60 * 60} />}
          {isTeacher && <NavAdmin />}
          {/* {isStudent && <NavStudent />} */}
          {!isTeacher && <NavStudent />}
          <div className="content">
            <div className="w-100">
              <Switch>
                {/* <Route path="/enterthematic" exact>
                  <Redirect to={redirectTo} />
                </Route> */}
                <Route path="/enterthematic" exact>
                  <PageThemeReportsLogin />
                </Route>
                <Route path="/enterthematic/management">
                  <PageThemeReportsManagement />
                </Route>

                <Route path="/enterthematic/details">
                  <PageThemeReportsDetails />
                </Route>
                <Route exact path="/enterthematic/announcements/:_id">
                  <PageAnnouncement />
                </Route>
                <Route exact path="/enterthematic/announcements">
                  <PageThemeReportsAnnouncements />
                </Route>

                <Route path="*">
                  <PageNotFound vAlign />
                </Route>
              </Switch>
            </div>
          </div>
        </Layout>
      </Router>
    </ModalAlert>
  );
};

export default ThemeReports;
